export default "__VITE_ASSET__BGpVGzbN__"